exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZoomButton-module__wrapper___1pBD_{background:#181818;border-radius:15px;padding:1em;display:grid;gap:1em;justify-content:center}.ZoomButton-module__in___1QxMW,.ZoomButton-module__out___XvT9v{width:40px;height:40px;background:#fff;color:#181818;border-radius:100%}.ZoomButton-module__in___1QxMW svg,.ZoomButton-module__out___XvT9v svg{font-size:20px}", ""]);

// exports
exports.locals = {
	"wrapper": "ZoomButton-module__wrapper___1pBD_",
	"in": "ZoomButton-module__in___1QxMW",
	"out": "ZoomButton-module__out___XvT9v"
};